export const INSPECT_WEBHOOK_COMPLETED = 'schedule.inspect.completed' as const;

export const INSPECT_WEBHOOK_URL_STATUS_CHANGED =
  'schedule.inspect.url_status_changed' as const;

export const INSPECT_PER_URL_WEBHOOK_EVENTS = [
  'schedule.inspect.url_matched',
  INSPECT_WEBHOOK_URL_STATUS_CHANGED,
] as const;

export type InspectPerUrlWebhookEvent =
  (typeof INSPECT_PER_URL_WEBHOOK_EVENTS)[number];

export const WEBHOOK_BUCKET_IDS = ['indexed', 'excluded', 'error'] as const;

export function hasInspectPerUrlWebhook(events: string[]): boolean {
  return events.some((id) =>
    (INSPECT_PER_URL_WEBHOOK_EVENTS as readonly string[]).includes(id),
  );
}

export function ensureWebhookBucketFilters(filters: string[]): string[] {
  const subs = filters.filter((id) => id.startsWith('excluded:'));
  const buckets = WEBHOOK_BUCKET_IDS.filter((id) => filters.includes(id));
  if (buckets.length > 0) {
    return [...buckets, ...subs];
  }
  return [...WEBHOOK_BUCKET_IDS, ...subs];
}
